import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app-config';
import { APP_CONFIG } from 'src/app/app-config.token';
import { BYPASS_ERROR_HANDLER } from 'src/app/common/utils/http-context-tokens';
import { ApiResult } from 'src/app/models/ApiResult';
import { ImportFromExternalSystemRequest, ImportFromExternalSystemResponse } from './import-from-external-system.model';

@Injectable({ providedIn: 'root' })
export class ImportFromExternalSystemService {
    private http = inject(HttpClient);
    private config = inject<AppConfig>(APP_CONFIG);

    private get url(): string {
        return `${this.config.resourceApiURI}/workers/importFromExternalSystem`;
    }

    import(request: ImportFromExternalSystemRequest): Observable<ApiResult<ImportFromExternalSystemResponse>> {
        const context = new HttpContext().set(BYPASS_ERROR_HANDLER, true);
        return this.http.post<ApiResult<ImportFromExternalSystemResponse>>(this.url, request, { context });
    }
}